import { Evaluation } from './Evaluation';

export declare interface StoryData {
	info: StoryInfo,
	positions: Position[][],
	zoomHistory?: number[],
	audio?: Blob,
}

export declare interface SelectedStory {
	campaign_id: string,
	student_id: string
}

export declare interface StoryInfo {
	_id: string,
	campaign: string,
	student: string,
	date: Date,
	lengthInSeconds: number,
	evaluations: Evaluation[],
	important?: boolean,
	graded?: boolean
}

export function emptyStory(id){
	let story: StoryData = {
		info: {
			_id: id,
			date: null,
			campaign: null,
			student: null,
			lengthInSeconds: null,
			evaluations: null
		},
		positions: null,
		audio: null
	}

	return story;
}

export declare interface Position {
	x: number,
	y: number
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/models/Story.ts